module.exports = __webpack_public_path__ + "img/Characteristics.f1618c0c.jpg";